import { useMyHubsList } from "hooks";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import "./HubFilterCreateOrder.scss";

const HubFilterCreateOrder = props => {
  const {
    defaultHubSelect,
    mainFilterParams,
    setMainFilterParams,
    handleChangeHub,
    handleSelectHub,
    isNotFilterChildHub = false,
    isHaveAllOption = false,
    isFilterAllDefault = false,
    label,
    isHidden = false,
    queryKey = "",
  } = props;

  const ALL_OPTIONS = {
    name: "Tất cả",
    id: "all",
  };

  const [isHubFilter, setIsHubFilter] = useState(false);
  const [hubsFilter, setHubsFilter] = useState([]);
  const [selectedHubFilter, setSelectedHubFilter] = useState("");

  // Helper: Flatten hub tree
  const collectAll = node => {
    const list = [];
    const dfs = n => {
      if (!n) return;
      list.push(n);
      (n.childs_hub || []).forEach(dfs);
    };
    dfs(node);
    return list;
  };

  // Process hub data
  const processHubData = res => {
    const { childs_hub, hub } = res;
    const rootWithChildren = {
      ...hub,
      childs_hub,
    };
    const flatChildren = collectAll({ childs_hub })
      .slice(1)
      .map(h => ({
        ...h,
      }));
    return [rootWithChildren, ...flatChildren];
  };

  // Chỉ call API hub mới (O)
  const { data: hubsNew, refetch: refetchHubsNew } = useMyHubsList({
    enabled: true,
    queryKey: `${queryKey}_new`,
    params: {
      is_new_address: "O",
    },
  });

  // Khi có dữ liệu hub -> xử lý
  useEffect(() => {
    if (!hubsNew) return;

    const processed = processHubData(hubsNew);
    let hubFilter_ = processed;

    if (isHaveAllOption) {
      hubFilter_.unshift({
        name: "Tất cả",
        id: "all",
        childs_hub: hubFilter_,
      });
    }

    setHubsFilter(hubFilter_);
    setDefaultFilter(hubFilter_);
  }, [hubsNew]);

  const setDefaultFilter = hubFilter_ => {
    let defaultHubFilter, defaultFilterIds, selectedName;

    if (isFilterAllDefault && isHaveAllOption) {
      defaultHubFilter = hubFilter_[0];
      defaultFilterIds = hubFilter_.filter(h => h.id !== "all").map(h => h.id);
      selectedName = "Tất cả";
    } else {
      const rootHub = hubFilter_.find(h => h.id !== "all");
      defaultHubFilter = defaultHubSelect || rootHub;

      const collectIds = n => {
        const ids = [];
        const dfs = x => {
          if (x?.id) ids.push(x.id);
          (x?.childs_hub || []).forEach(dfs);
        };
        dfs(n);
        return ids;
      };

      defaultFilterIds = isNotFilterChildHub
        ? [defaultHubFilter?.id]
        : collectIds(defaultHubFilter);

      selectedName = defaultHubFilter?.name;
    }

    setMainFilterParams(prev => ({
      ...prev,
      page: 1,
      keywords: "",
      columnFilter: {
        ...prev.columnFilter,
        "filter[hub_id][in]": defaultFilterIds,
      },
    }));

    handleSelectHub &&
      handleSelectHub(
        defaultFilterIds,
        isHaveAllOption && isFilterAllDefault,
        defaultHubFilter
      );

    setSelectedHubFilter(selectedName);
  };

  const handleSelectHubFilter = hub => {
    handleChangeHub && handleChangeHub();
    const { childs_hub } = hub;
    const columnFilterKeep = { ...mainFilterParams.columnFilterKeep };
    setIsHubFilter(false);

    if (hub.id) {
      setSelectedHubFilter(hub.name);
      let idsFilter = [];

      if (hub.id === ALL_OPTIONS.id) {
        idsFilter = hubsFilter
          .filter(h => h.id !== ALL_OPTIONS.id)
          .map(h => h.id);
      } else {
        idsFilter = [hub.id];
        if (childs_hub && !isNotFilterChildHub) {
          idsFilter = [...idsFilter, ...childs_hub.map(c => c.id)];
        }
      }

      columnFilterKeep["filter[hub_id][in]"] = idsFilter;
      const isSelectAll = isHaveAllOption && hub.id === ALL_OPTIONS.id;
      handleSelectHub && handleSelectHub(idsFilter, isSelectAll, hub);
    } else {
      setSelectedHubFilter("");
      delete columnFilterKeep["filter[hub_id][in]"];
    }

    setMainFilterParams(prev => ({
      ...prev,
      page: 1,
      keywords: "",
      columnFilterKeep,
      columnFilter: {
        ...prev.columnFilter,
        ...columnFilterKeep,
      },
    }));
  };

  // Refetch khi mount
  useEffect(() => {
    refetchHubsNew();
  }, []);

  return (
    !isHidden && (
      <div className="HubFilterCreateOrder">
        <Dropdown
          disabled={defaultHubSelect}
          isOpen={isHubFilter}
          toggle={() => setIsHubFilter(!isHubFilter)}
        >
          <DropdownToggle className="btn primary-btn w-100 text-overflow" caret>
            {label ? label : "Center/Hub"}
            {selectedHubFilter && <span>:&nbsp;{selectedHubFilter}</span>}
            <i className="mdi mdi-chevron-down" />
          </DropdownToggle>
          <DropdownMenu className="w-100">
            {hubsFilter?.map((hub, index) => (
              <DropdownItem
                key={`hub-${index}`}
                onClick={() => handleSelectHubFilter(hub)}
              >
                {hub?.name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    )
  );
};

HubFilterCreateOrder.propTypes = {
  defaultHubSelect: PropTypes.any,
  queryKey: PropTypes.any,
  mainFilterParams: PropTypes.any.isRequired,
  setMainFilterParams: PropTypes.any.isRequired,
  handleChangeHub: PropTypes.any,
  handleSelectHub: PropTypes.any,
  isNotFilterChildHub: PropTypes.any,
  isHaveAllOption: PropTypes.bool,
  isFilterAllDefault: PropTypes.bool,
  isHidden: PropTypes.bool,
};

export default HubFilterCreateOrder;
